import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/testimonials';
import { inViewOnce, reveal } from '../utils/motion';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonials-heading" className="flex flex-col gap-[30px] pt-2" data-id="element-116" data-mp="1n0tyt76ofxev">
      <h2 id="testimonials-heading" className="text-headline font-semibold" data-id="element-117" data-mp="1r140w8rcm3og">
        Working with me
      </h2>
      <ul className="grid grid-cols-1 gap-[30px] md:grid-cols-3" data-id="element-118" data-mp="1d0tbla5osx5e">
        {testimonials.map((t, i) => <motion.li key={t.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={inViewOnce} transition={{
        ...reveal,
        delay: i * 0.06
      }} data-id="element-119" data-mp="1i1z8zlaal8l9" data-mpi={i}>
            <figure className="flex h-full flex-col gap-6 rounded-[30px] bg-black/[0.03] p-6" data-id="element-120" data-mp="184uixadbssz6">
              <blockquote className="text-base leading-[1.6]" data-id="element-121" data-mp="2yd336lr1t59i">
                <p data-id="element-122" data-mp="32frbmsbuoa5y">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4" data-id="element-123" data-mp="2v1b08w6o5uny">
                <img src={t.photo} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover" data-id="element-124" data-mp="2uzhs1cger2du" />
                <div className="flex flex-col text-sm leading-[1.4]" data-id="element-125" data-mp="2q0ewcimbi8ij">
                  <span className="text-base font-semibold" data-id="element-126" data-mp="34q2puxo9c2vp">{t.name}</span>
                  <span className="text-muted" data-id="element-127" data-mp="2zs13o3vjbng0">{t.role}</span>
                  <span className="text-muted" data-id="element-128" data-mp="2zundyb9t8h1x">{t.company}</span>
                </div>
              </figcaption>
            </figure>
          </motion.li>)}
      </ul>
    </section>;
}